import axiosClient from './axiosClient';

export interface AuthUser {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: 'user' | 'admin';
}

export interface AuthResponse {
  accessToken: string;
  user: AuthUser;
}

export interface RegisterPayload {
  firstName?: string;
  lastName?: string;
  email: string;
  password?: string;
  acceptedTerms: boolean;
}

export interface LoginPayload {
  email: string;
  password?: string;
}

export const loginUser = async (
  payload: LoginPayload
): Promise<AuthResponse> => {
  const res = await axiosClient.post<AuthResponse>('/auth/login', payload);
  console.log('Login response:', res.data);
  return res.data;
};

export const registerUser = async (
  payload: RegisterPayload
): Promise<AuthUser> => {
  const res = await axiosClient.post<AuthUser>('/auth/register', payload);
  return res.data;
};

export const logoutUser = async (): Promise<{ message: string }> => {
  const res = await axiosClient.post<{ message: string }>('/auth/logout');
  return res.data;
};

export const refreshUserSession = async (): Promise<AuthResponse> => {
  const res = await axiosClient.post<AuthResponse>('/auth/refresh');
  return res.data;
};

export const activateUser = async (token: string): Promise<AuthResponse> => {
  const res = await axiosClient.post<AuthResponse>('/auth/activate', { token });
  return res.data;
};

export const deleteUserProfile = async (): Promise<{ message: string }> => {
  const res = await axiosClient.delete<{ message: string }>('/auth/profile');
  return res.data;
};

export const changePassword = async (
  currentPassword: string,
  newPassword: string
): Promise<{ message: string }> => {
  const res = await axiosClient.post<{ message: string }>(
    '/auth/change-password',
    {
      currentPassword,
      newPassword
    }
  );
  return res.data;
};
